/** Completion is explicit; reaching delivery or the installation lane is not completion. */
export function isOperationsOrderComplete(order: any): boolean {
  return !!(order?.status === 'completed' || order?.pipeline?.complete ||
    order?.pipeline?.installed || order?.status_obj?.installComplete)
}

export function operationsUrgency(order: any, now = Date.now()): 'normal' | 'overdue' | 'urgent' | 'soon' {
  if (isOperationsOrderComplete(order) || !order?.dueDate) return 'normal'
  const daysUntilDue = Math.ceil((new Date(order.dueDate).getTime() - now) / 86400000)
  if (daysUntilDue < 0) return 'overdue'
  if (daysUntilDue <= 3) return 'urgent'
  if (daysUntilDue <= 7) return 'soon'
  return 'normal'
}
